import { IGetAllFolhaPagamentoItensUseCase } from "../../../presentation/useCases/read/get_all_folha_pagamento_itens_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ItemFolhaPagamento } from "../../models/item_folha_pagamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllFolhaPagamentoItensUseCase
 */

export class GetAllFolhaPagamentoItensUseCase
  extends BasePaginatedUseCase<ItemFolhaPagamento>
  implements IGetAllFolhaPagamentoItensUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllFolhaPagamentoItens(
    idFolhaPagamento: number,
    idCentroCusto: number | null,
    idFuncionario: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllFolhaPagamentoItens(
      idFolhaPagamento,
      idCentroCusto,
      idFuncionario,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
